// pages/AboutPage.js
import React from 'react';
import About from '../components/HomePage/About';
import Jobs from '../components/JobsPage/Jobs';

function JobsPage() {
  return (
    <div>
      <Jobs />
    </div>
  );
}

export default JobsPage;
